<template>
  <div ref="htmlContent" v-html="perInfoList"></div>
</template>

<script>
import axios from "axios";

export default {
  // 个人信息收集清单
  name: 'perInfoList',
  data() {
    return {
      perInfoList: '',
    }
  },
  async mounted() {
    // 通过CDN获取到隐私协议的内容
    try {
      const response = await axios.get(`https://cdn-product-prod.cotticoffee.com/cottiCoffee-api/privacy/perInfoList.html?v=${new Date().getTime()}`)
      this.perInfoList = response.data
    } catch (error) {
      console.error('加载隐私协议失败:', error);
    }
  }
}
</script>

<style scoped lang="scss">

.scroll-hide {
  width: 100%;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
  overflow-scrolling: touch;
  overflow-y: scroll;
  position: fixed;
  position: -ms-device-fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}

.privacy {
  padding: 32px 0;
  font-size: 24px;
  line-height: 40px;
  word-break: break-all;
  background: #F8F8F8;

  .bold {
    font-weight: bold !important;

    .child-herf {
      color: #346EF4;

    }
  }

  .title {
    font-weight: bold !important;
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 32px;
  }

  .header {
    font-weight: 500;
    padding: 0 32px;
    color: #3A3B3C;
    border-bottom: 1px solid #eee;
    margin-bottom: 32px;
    line-height: 40px;

    .version {
      margin-bottom: 12px;
    }

    .updateTime {
      margin-bottom: 12px;
    }

    .effectiveTime {
      margin-bottom: 40px;
    }
  }

  .content {
    font-size: 24px;
    color: #3A3B3C;
    line-height: 48px;
    margin-bottom: 160px;

    .section {
      padding: 0 32px;
      margin: 24px 0 16px 0;
      line-height: 48px;
      font-size: 28px;
      font-weight: 500;
    }

    .text {
      padding: 0 32px;
      font-size: 24px;
      font-weight: 400;
    }
  }
}
</style>
